import axios from "axios";
import { clearCookies, getToken } from "../../utils/cookies.helpers";
import config from "../../config/config";

const apiClient = async (options) => {
  const baseURL = config.apiUrl;
  const client = axios.create({ baseURL });

  const token = getToken();
  if (token) {
    client.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await client(options);
    if (!response.data) throw new Error("API Request Was Not Successful");
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;

      if (status === 401 || status === 403) {
        clearCookies();
        window.location.href = "/auth/sign-in";
      }

      const errorObj = {
        status,
        message:
          error.response?.data?.message ||
          error.message ||
          "Unknown error occurred.",
      };
      throw errorObj;
    }

    throw { message: error.message || "An unknown error occurred." };
  }
};

export default apiClient;
